import React from "react";
import { PALETTE } from "../../common/ThemeConstants";
import SuperserieForm from "./SuperserieForm";
import CardAdminSuperserie from "./CardAdminSuperserie";
import { getRequest, deleteRequest } from "../../api/axiosRequests";
import AlertModal from "../../common/components/AlertModal";
import CategoryTagCard from "../../workout/components/CategoryTagCard";

import { Col, Row, Button } from "react-bootstrap";
import { useState, useEffect } from "react";
import { IoIosArrowDown, IoIosArrowForward, IoIosArrowUp } from "react-icons/io";

export default function CardAdminWorkout({
  workout,
  height = 100,
  editCallback,
}) {
  const [isSelected, setIsSelected] = useState(false);
  const [categoryName, setCategoryName] = useState("");
  const [workoutSuperseries, setWorkoutSuperseries] = useState([]);
  const [currentSuperserie, setCurrentSuperserie] = useState({ id: -1 });
  const [showEditForm, setShowEditForm] = useState(false);
  const [showDeleteForm, setShowDeleteForm] = useState(false);

  async function fetchData() {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const promise1 = getRequest("superserieList/", headers);
    const promise2 = getRequest("categoryList/", headers);
    Promise.all([promise1, promise2])
      .then((values) => {
        const superseriesData = values[0]["data"];
        const categoriesData = values[1]["data"];
        const filteredSuperseries = superseriesData
          .filter((el) => el.workout === workout.id)
          .sort((a, b) => (a.position > b.position ? 1 : -1));
        setWorkoutSuperseries(filteredSuperseries);
        const cat = categoriesData.filter(
          (category) => category.id === workout.category
        );
        if (cat.length > 0) {
          setCategoryName(cat[0].name);
        } else {
          setCategoryName("No found");
        }
      })
      .catch((errs) => { });
  }

  const getCategoryColor = (categoryName) => {
    switch (categoryName) {
      case "Workout":
        return PALETTE.MAINCOLORLIGHT;
      case "Postural":
        return PALETTE.SECONDARYCOLORLIGHT;
      case "Personal":
        return PALETTE.LIGHTGRAY;
      default:
        return PALETTE.GRAY;
    }
  };

  const resetCurrentSuperserie = () => {
    setCurrentSuperserie({ id: -1 });
  };

  const onAddSuperserieButtonClicked = () => {
    resetCurrentSuperserie();
    setShowEditForm(true);
  };

  const onEditFormSubmit = () => {
    fetchData();
    setShowEditForm(false);
  };

  const onDeleteSuperserieButtonClicked = (id) => {
    const superserie = workoutSuperseries.filter((w) => w.id === id)[0];
    setCurrentSuperserie(superserie);
    setShowDeleteForm(true);
  };

  const superserieEditFormCallback = (id) => {
    const superserie = workoutSuperseries.filter((s) => s.id === id)[0];
    setCurrentSuperserie(superserie);
    setShowEditForm(true);
  };

  function getNextSuperseriePosition() {
    if (workoutSuperseries.length == 0) {
      return 0;
    }
    return workoutSuperseries.at(-1).position + 1;
  }

  async function deleteCallback(id) {
    const headers = { Authorization: localStorage.getItem("jwt") };
    const response = await deleteRequest("superserie/" + id, headers);
    setShowDeleteForm(false);
    fetchData();
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <AlertModal
        show={showDeleteForm}
        getDataId={() => {
          return currentSuperserie.id;
        }}
        onHide={() => {
          setShowDeleteForm(false);
        }}
        onCancel={() => {
          setShowDeleteForm(false);
        }}
        onConfirm={(id) => {
          deleteCallback(id);
        }}
        title={"Delete superserie"}
        description={
          "Are you sure you want to delete the superserie? Also the associated exercises will be deleted"
        }
      />
      <SuperserieForm
        idWorkout={workout.id}
        getCurrentSuperserie={() => {
          return currentSuperserie;
        }}
        getPos={() => {
          return getNextSuperseriePosition();
        }}
        onHide={() => {
          setShowEditForm(false);
        }}
        show={showEditForm}
        onSubmit={onEditFormSubmit}
      />
      <div
        className="my-2 shadow-sm rounded-md"
        style={{ border: "solid 0px", backgroundColor: PALETTE.WHITE }}
      >
        <Row
          className="g-0 align-items-center"
          style={{ cursor: "pointer" }}
          onClick={() => {
            editCallback(workout.id);
          }}
        >
          <Col xs={3} className="align-self-center text-start p-1">
            <img
              className="rounded-md"
              style={{
                objectFit: "cover",
                height: height,
                width: height,
                maxWidth: "100%",
              }}
              src={workout.cover}
              alt={workout.name}
            />
          </Col>
          <Col xs={7} className="text-start">
            <p className="cardDescription" style={{ marginBottom: "4px" }}>
              {workout.name}
            </p>
            <span className="px-2 py-1 rounded-sm" style={{ background: getCategoryColor(categoryName), fontSize: 12, color: PALETTE.DARK }}>{categoryName}</span>
            <span className="px-2 py-1 rounded-sm mx-1" style={{ background: PALETTE.LIGHTGRAY, fontSize: 12, color: PALETTE.DARK }}>{`Livello ${workout.level}`}</span>
            <span className="px-2 py-1 rounded-sm" style={{ background: PALETTE.LIGHTGRAY, fontSize: 12, color: PALETTE.DARK }}>{`Minuti ${workout.duration}`}</span>
          </Col>
          <Col xs={2} className="align-self-center text-end px-2">
            <IoIosArrowForward size={25} color={PALETTE.GRAY} />
          </Col>
        </Row>
        {isSelected && (
          <Row>
            <div className="d-grid gap-2">
              {workoutSuperseries.map((superserie, idx) => (
                <div key={idx}>
                  <CardAdminSuperserie
                    superserie={superserie}
                    editCallback={superserieEditFormCallback}
                    onDeleteButtonClicked={() => {
                      onDeleteSuperserieButtonClicked(superserie.id);
                    }}
                  />
                </div>
              ))}
              <Button
                className="rounded py-3 mx-2 my-1"
                style={{
                  backgroundColor: PALETTE.KINDALIGHTGRAY,
                  color: PALETTE.DARK,
                  border: "0",
                }}
                onClick={onAddSuperserieButtonClicked}
              >
                Add Superserie
              </Button>
            </div>
          </Row>
        )}
        <Row
          className="py-1 mt-1 g-0 rounded-md-bottom"
          style={{ cursor: "pointer", backgroundColor: PALETTE.LIGHTGRAY }}
          onClick={() => setIsSelected(!isSelected)}
        >
          <Col className="align-self-center text-center">
            {isSelected && <IoIosArrowUp size={25} color={PALETTE.GRAY} />}
            {!isSelected && <IoIosArrowDown size={25} color={PALETTE.GRAY} />}
          </Col>
        </Row>
      </div>
    </>
  );
}
